import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('ui.components.CrashedComponentPlaceholder', {
    weCouldntLoad: 'We couldn’t load the content :(',
    pleaseReload: "Please reload this page. If this doesn't help, please contact support.",
    contactSupport: 'Contact support',
    reloadPage: 'Reload Page',
});
